import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1694.244,1694.064 L1129.404,1694.064 L790.644,1694.064 L225.924,1694.064 L225.924,225.864 L1694.244,225.864 L1694.244,1694.064 Z M1694.124,0.024 L225.924,0.024 C101.364,0.024 -0.036,101.304 -0.036,225.864 L-0.036,1694.064 C-0.036,1818.744 101.364,1920.024 225.924,1920.024 L1694.124,1920.024 C1818.684,1920.024 1919.964,1818.744 1919.964,1694.064 L1919.964,225.864 C1919.964,101.304 1818.684,0.024 1694.124,0.024 L1694.124,0.024 Z M635.388,1599.024 L959.988,1274.424 L1284.588,1599.024 L1599.108,1284.624 L1274.508,960.024 L1599.108,635.424 L1284.588,320.904 L959.988,645.504 L635.388,320.904 L320.868,635.424 L645.468,960.024 L320.868,1284.624 L635.388,1599.024 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconTableDeleteTableSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconTableDeleteTableSolid, _Component);

  var _super = _createSuper(IconTableDeleteTableSolid);

  function IconTableDeleteTableSolid() {
    _classCallCheck(this, IconTableDeleteTableSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconTableDeleteTableSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconTableDeleteTable",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconTableDeleteTableSolid.displayName = "IconTableDeleteTableSolid";
  return IconTableDeleteTableSolid;
}(Component);

IconTableDeleteTableSolid.glyphName = 'table-delete-table';
IconTableDeleteTableSolid.variant = 'Solid';
IconTableDeleteTableSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconTableDeleteTableSolid;
export { IconTableDeleteTableSolid };